export default function(html) {
	html.querySelectorAll('[data-bs-toggle=modal][data-url]').forEach((el) => {
		el.addEventListener('click', (e) => {
			const loader = document.querySelector('#contentPreviewLoader')
			loader.classList.remove('d-none')

			const iframe = document.querySelector('#contentPreviewModal iframe')
			iframe.classList.add('d-none')

			const url = e.currentTarget.getAttribute('data-url')
			if (url) {
				const callback = (e) => {
					loader.classList.add('d-none')
					e.currentTarget.classList.remove('d-none')
				}

				iframe.removeEventListener('load', callback)
				iframe.addEventListener('load', callback)

				iframe.setAttribute('src', url)

			} else {
				alert('URL not found.')
			}
		})
	})
}
